/* eslint-disable no-unused-expressions */

import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import sysJwt from "../../../utils/sysJwt";
import SysForm from "../../commonComponents/sysForm";
import { post } from "../../../utils/sysAxios";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { confirmAlert } from "react-confirm-alert";
import SysTable from "../../commonComponents/SysTable";
import InfoPopUp from "../../commonComponents/infoPopUp";

class VoucherTypes extends Component {
  state = {
    data: {
      typeEn: "",
      typeAr: "",
      typeKu: "",
      price: "",
    },

    contentHeader: "Voucher Types",
    addButtonLabel: "Add Voucher Types",
    addButtonIcon: "fa fa-plus",

    dataUrl: "/api/data/GetVoucherTypes",
    singleItemUrl: "/api/data/GetVoucherType",
    addUrl: "/api/data/AddVoucherType",
    editUrl: "/api/data/EditVoucherType",

    inEditMode: false,
    inModalMode: false,
    modalHeaderAdd: "Add Voucher Types",
    modalSubmitButtonLabelAdd: "Add",
    modalSubmitButtonIconAdd: "fa fa-plus",
    modalHeaderEdit: "Edit Voucher Types",
    modalSubmitButtonLabelEdit: "Edit",
    modalSubmitButtonIconEdit: "fa fa-edit",
    modalWidth: "50vw",

    editEntityId: 0,

    tableData: [],
  };

  getColumns() {
    const { t } = this.props;
    return [
      {
        id: 1,
        label: t("col.id"),
        field: "ID",
      },
      {
        id: 2,
        label: t("col.typeEn"),
        field: "VOUCHER_TYPE_EN",
      },
      {
        id: 3,
        label: t("col.typeAr"),
        field: "VOUCHER_TYPE_AR",
      },
      {
        id: 4,
        label: t("col.typeKu"),
        field: "VOUCHER_TYPE_KU",
      },
      {
        id: 5,
        label: t("col.price"),
        field: "PRICE",
      },
      {
        id: 6,
        label: t("col.insertDate"),
        field: "INSERT_DATE",
      },
      {
        id: 7,
        label: t("col.lastUpdate"),
        field: "LAST_UPDATE",
      },
      {
        id: 8,
        label: t("col.actions"),
        field: "SYS_ACTINOS",
        width: "100px",
        maxResizeWidth: "100px",
        resizable: false,
        pinned: true,
        cellRenderer: ({ data }) => {
          return (
            <div id="outer">
              {sysJwt.isAuthorized(["CB39"]) && (
                <div className="inner" title="Edit">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => {
                      this.getEditFormData(data).then(() => {
                        this.setState({
                          inEditMode: true,
                        });
                        this.showForm();
                      });
                    }}
                  >
                    <i className="fa fa-edit" />
                  </button>
                </div>
              )}
            </div>
          );
        },
      },
    ];
  }

  componentDidMount() {
    this.getData();
  }

  updateForm = (inputId, inputValue) => {
    var data = this.state.data;
    data[inputId] = inputValue;
    this.setState({ data });
  };

  showForm() {
    this.setState({ inModalMode: true });
  }

  closeModal() {
    var data = this.state.data;

    Object.keys(data).forEach(function (key) {
      Array.isArray(data[key]) ? (data[key] = []) : (data[key] = "");
    });

    this.setState({
      inModalMode: false,
      inEditMode: false,
      data: data,
      editEntityId: 0,
      allClaims: [],
    });

    this.getData();
  }

  getData() {
    post(this.state.dataUrl, null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({ tableData: apiResponse.data.respData.data });
      }
    );
  }

  getEditFormData(row) {
    return post(
      this.state.singleItemUrl,
      { id: row.ID },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      var data = this.state.data;

      data["typeEn"] = apiResponse.data.respData.data[0].VOUCHER_TYPE_EN;
      data["typeAr"] = apiResponse.data.respData.data[0].VOUCHER_TYPE_AR;
      data["typeKu"] = apiResponse.data.respData.data[0].VOUCHER_TYPE_KU;
      data["price"] = apiResponse.data.respData.data[0].PRICE;

      this.setState({
        data: data,
        editEntityId: apiResponse.data.respData.data[0].ID,
      });
    });
  }

  doSubmit() {
    const submitData = Object.assign({}, this.state.data);

    if (this.state.inEditMode) {
      submitData["id"] = this.state.editEntityId;
    }
    post(
      this.state.inEditMode ? this.state.editUrl : this.state.addUrl,
      submitData,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        this.props.updateIsLoading(false);
        this.closeModal();
      }
    });
  }

  render() {
    const { t } = this.props;
    return (
      <div className="bms-content-component fade-in">
        <div className="row">
          <div className="col">
            <h4>{t("pages.electricityItems")}</h4>
          </div>
          <div className="col flex-container-left">
            {sysJwt.isAuthorized(["CB38"]) && (
              <Button
                label={t("btn.addVoucherType")}
                icon={this.state.addButtonIcon}
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => {
                  this.setState({ inEditMode: false });
                  this.showForm();
                }}
              />
            )}
          </div>
        </div>
        <hr />
        <Dialog
          visible={this.state.inModalMode}
          style={{ width: this.state.modalWidth }}
          onHide={(e) => this.closeModal()}
          dismissableMask={true}
          closable={false}
          header={
            <h5 className="modal-header">
              {this.state.inEditMode ? t("dialog.editTitle") : t("dialog.addTitle")}
            </h5>
          }
          footer={
            <div>
              <Button
                label={this.state.inEditMode ? t("btn.edit") : t("btn.add")}
                icon={
                  this.state.inEditMode
                    ? this.state.modalSubmitButtonIconEdit
                    : this.state.modalSubmitButtonIconAdd
                }
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.doSubmit()}
              />
              <Button
                label={t("btn.cancel")}
                icon="fa fa-close"
                className="p-button-rounded p-button-danger"
                onClick={() => this.closeModal()}
              />
            </div>
          }
        >
          <SysForm
            isLoading={this.props.isLoading}
            inEditMode={this.state.inEditMode}
            data={this.state.data}
            updateForm={this.updateForm}
            inputs={[
              {
                type: "text",
                id: "typeEn",
                label: t("col.typeEn"),
                disabled: false,
              },
              {
                type: "text",
                id: "typeAr",
                label: t("col.typeAr"),
                disabled: false,
              },
              {
                type: "text",
                id: "typeKu",
                label: t("col.typeKu"),
                disabled: false,
              },
              {
                type: "text",
                id: "price",
                label: t("col.price"),
                disabled: false,
              },
            ]}
          />
        </Dialog>
        <SysTable
          columns={this.getColumns()}
          rows={this.state.tableData}
          pageSizes={[10, 15, 20, 25, 30]}
        />
      </div>
    );
  }
}

export default withTranslation()(VoucherTypes);
